/**
 * «Мужской» / «Женский», as two segments in the same tray the voice part uses.
 *
 * It exists because a voice part cannot answer this question: «тенор» and «бас»
 * are not the same thing as a man, and the queue of sermons is built from it.
 *
 * The words were «брат» and «сестра» until 2026-08-24. They are what the choir
 * calls each other and they were the wrong thing to ask on a form: a person
 * filling in a profile answers the question every other application asks them,
 * and «брат» is a standing in a congregation rather than a field. What is
 * stored did not move with the words — the column and the API field are still
 * `is_brother`, because the rota asks «who may preach» and that is this same
 * question under its church name.
 *
 * There is no «не указано» segment to press. Not stated is where everybody
 * starts, and a third option would offer a person a way to say nothing about
 * themselves that nobody would ever choose on purpose; what it does instead is
 * leave both halves unpicked, which is the same grammar as an RSVP nobody has
 * answered.
 */
export default function SexSegments({
  value,
  busy,
  onPick,
}: {
  value: boolean | null;
  busy?: boolean;
  onPick: (isBrother: boolean) => void;
}) {
  return (
    <div className="parts">
      <button
        className={value === true ? 'part part--picked' : 'part'}
        aria-pressed={value === true}
        disabled={busy}
        onClick={() => onPick(true)}
      >
        Мужской
      </button>
      <button
        className={value === false ? 'part part--picked' : 'part'}
        aria-pressed={value === false}
        disabled={busy}
        onClick={() => onPick(false)}
      >
        Женский
      </button>
    </div>
  );
}
